module.exports = __webpack_public_path__ + "static/media/Frame 316.d30852f3.png";